import { connect } from 'react-redux';

// action creators
import { push } from 'react-router-redux';

// components
import HeaderMenu from './HeaderMenu';

// helpers
import getPathWithSearch from '../../../../helpers/getPathWithSearch';

const mapStateToProps = state => ({
  router:         state.get('router'),
  currentChapter: state.get('currentChapter'),
  currentUser:    state.get('currentUser'),
});

const mapDispatchToProps = (dispatch) => ({
  navigate: (route, queryParams = {}) => {
    dispatch(push(getPathWithSearch(route, queryParams)));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderMenu);
